import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';

const rootDom = document.getElementById('form');
if (rootDom) {
  const contentId = rootDom.getAttribute('data-content-id');
  const formType = rootDom.getAttribute('data-form-type');
  const trialType = rootDom.getAttribute('data-trial-type');
  const trialLength = rootDom.getAttribute('data-trial-length');
  const root = createRoot(rootDom);
  root.render(
    <App contentId={contentId} formType={formType} trialType={trialType} trialLength={Number(trialLength)} />
  );
}

const formModalDom = document.getElementById('form-modal');
if (formModalDom) {
  const modalRoot = createRoot(formModalDom);
  modalRoot.render(<App modal={true} />);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
